import { render } from "./object-card.vue?vue&type=template&id=38905925"
import script from "./object-card.vue?vue&type=script&setup=true&lang=js"
export * from "./object-card.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/object/object-card/object-card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38905925"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38905925', __exports__)) {
    api.reload('38905925', __exports__)
  }
  
  module.hot.accept("./object-card.vue?vue&type=template&id=38905925", () => {
    api.rerender('38905925', render)
  })

}


export default __exports__